import React, { useEffect, useState } from 'react'
import ModalCustom from '../../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
// import DatepickerCustom from '../../../datepicker-custom'
import moment from 'moment'

import Error_500 from '../../../error/error-500'
import { updateEjipRoundAPI } from '../../../../services/ejip'
import Error_false from '../../../error/error-false'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
import CustomDatePicker from '../../../custom/CustomDatePicker'
// import CustomDatePicker from '../../../datepicker-custiom-lock'
const schema = yup
  .object({
    roundName: yup.string().required('This is a required question'),
    openDate: yup.string().required('This is a required question'),
    endDate: yup.string().required('This is a required question')
  })
  .required()
export default function ModalEditRound({
  isModalOpen,
  handleCancel,
  fnData,
  fundId,
  dataById
}) {
  const [isSave, setIsSave] = useState(false)
  const [endDate, setEndDate] = useState(null)
  const [startDate, setStartDate] = useState(null)

  useEffect(() => {
    if (dataById) {
      setValue('roundName', dataById.round)
      setValue('openDate', new Date(dataById.open_date))
      setValue('endDate', new Date(dataById.close_date))
      setEndDate(new Date(dataById.close_date))
      setStartDate(new Date(dataById.open_date))
    }
  }, [dataById])

  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const onSubmitEdit = async (d) => {
    try {
      setIsSave(true)
      const body = {
        fundId,
        roundId: dataById.round_id,
        round: d.roundName,
        openDate: moment(d.openDate).format('YYYY-MM-DD'),
        endDate: moment(d.endDate).format('YYYY-MM-DD')
      }

      const resp = await updateEjipRoundAPI(body)
      setIsSave(false)
      if (!resp) return
      if (resp.status) {
        SwalCustom({
          title: 'Success!',
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          handleCancel()
          const body = {
            page: 1,
            size: 20,
            fundId
          }
          fnData(body)
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <ModalCustom
      open={isModalOpen}
      width={600}
      centered
      onCancel={handleCancel}
    >
      <div></div>
      <Form onSubmit={handleSubmit(onSubmitEdit)}>
        <div className="row ">
          <div className="col-12 pt-3">
            <div> Round </div>

            <Controller
              name={'roundName'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
            {errors.roundName?.message && (
              <label className="small text-danger">
                {errors.roundName.message}
              </label>
            )}
          </div>
          <Col xl={6}>
            <div className="mt-3">
              <div> Fund Opening Date</div>

              <Controller
                name={'openDate'}
                control={control}
                render={({ field: { value = '', onChange } }) => (
                  <CustomDatePicker
                    dateFormat="dd/MM/yyyy"
                    maxDate={endDate}
                    id="picker-date-month-btn"
                    value={value}
                    onChange={(date) => {
                      onChange(date)
                      setStartDate(date)
                    }}
                  />
                )}
              />
              {errors.openDate?.message && (
                <label className="small text-danger">
                  {errors.openDate.message}
                </label>
              )}
            </div>
          </Col>
          <Col>
            <div className="mt-3 ">
              <div className=""> Fund End Date</div>
              <Controller
                name={'endDate'}
                control={control}
                render={({ field: { value = '', onChange } }) => (
                  <CustomDatePicker
                    dateFormat="dd/MM/yyyy"
                    id="picker-date-month-btn"
                    value={value}
                    onChange={(date) => {
                      onChange(date)
                      setEndDate(date)
                    }}
                    minDate={startDate}
                  />
                )}
              />
              {errors.endDate?.message && (
                <label className="small text-danger">
                  {errors.endDate.message}
                </label>
              )}
            </div>
          </Col>
        </div>

        <div className="col-12 mt-5 mb-3 d-flex gap-3 justify-content-center">
          <Button
            variant="outline-primary"
            style={{
              width: '130px'
            }}
            size="sm"
            // type="submit"
            className="rounded-3"
            onClick={handleCancel}
          >
            Cancel
          </Button>

          <Button
            className="btn btn-primary rounded-3"
            type="submit"
            style={{
              width: '130px'
            }}
            disabled={isSave}
            size="sm"
          >
            {isSave ? 'Apply...' : 'Apply'}
          </Button>
        </div>
      </Form>
    </ModalCustom>
  )
}
